import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectIcon12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectIcon12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.41 2H1.59L3.5 5.057zm.59.943L4.09 6 6 9.057zM2.91 6 1 2.943v6.114zm-1.32 4L3.5 6.943 5.41 10zM1.5 1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h4A1.5 1.5 0 0 0 7 9.5v-7A1.5 1.5 0 0 0 5.5 1zm7 2.5A.5.5 0 0 1 9 3h2.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M9 5a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectIcon12);
